/**
 * Indian rupee.
 */
export var INR = {
  code: 'INR',
  base: 10,
  exponent: 2
};